/**
 * HydroJug Ease2o Launch Landing Page JS
 * Smooth scroll, FAQ accordion (if not using hj-landing-faq), editor support
 */

(function () {
  'use strict';

  function init() {
    initSmoothScroll();
    initFaqAccordion();
    initCountdownShopNow();
    initProductCarousels();
  }

  /* ----------------------------------------
     Smooth Scroll for anchor links
     ---------------------------------------- */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#hje2o-"]');
      if (!link) return;
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ----------------------------------------
     FAQ Accordion (for hj-landing-faq blocks)
     ---------------------------------------- */
  function initFaqAccordion() {
    var faqItems = document.querySelectorAll('.hjlp-faq__question');
    faqItems.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.hjlp-faq__item');
        var isOpen = item.classList.contains('hjlp-faq__item--open');

        if (isOpen) {
          item.classList.remove('hjlp-faq__item--open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('hjlp-faq__item--open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ----------------------------------------
     Countdown → Shop Now reveal
     ---------------------------------------- */
  function initCountdownShopNow() {
    var section = document.querySelector('.hje2o-countdown');
    if (!section) return;

    var timer = section.querySelector('countdown-timer');
    if (!timer) return;

    var expiresAt = timer.getAttribute('expires-at');
    if (!expiresAt) return;

    var expirationDate = new Date(expiresAt);
    if (isNaN(expirationDate.getTime())) return;

    var timerWrap = section.querySelector('.hje2o-countdown__timer-wrap');
    var shopNow = section.querySelector('.hje2o-countdown__shop-now');

    function reveal() {
      if (timerWrap) timerWrap.classList.add('hje2o-countdown__timer-wrap--expired');
      if (shopNow) shopNow.classList.add('hje2o-countdown__shop-now--visible');
    }

    function check() {
      if (new Date() >= expirationDate) {
        reveal();
        clearInterval(interval);
      }
    }

    var interval = setInterval(check, 1000);
    check();
  }

  /* ----------------------------------------
     Product Carousels (Flickity)
     ---------------------------------------- */
  function initProductCarousels() {
    if (typeof Flickity === 'undefined') return;

    var carousels = document.querySelectorAll('[data-hje2o-carousel]');
    carousels.forEach(function (el) {
      if (el.classList.contains('flickity-enabled')) return;

      var slides = el.querySelectorAll('.hje2o-carousel__slide');
      if (slides.length === 0) return;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var multiSlide = slides.length > 1;

      var flkty = new Flickity(el, {
        cellAlign: 'center',
        contain: true,
        wrapAround: false,
        draggable: multiSlide,
        prevNextButtons: multiSlide,
        pageDots: multiSlide,
        autoPlay: false,
        accessibility: true,
        selectedAttraction: reducedMotion ? 1 : 0.025,
        friction: reducedMotion ? 1 : 0.28
      });

      /* Update tabindex so only the active slide is tabbable */
      function updateSlideFocus() {
        slides.forEach(function (slide, i) {
          var link = slide.querySelector('.hje2o-carousel__link');
          if (link) link.setAttribute('tabindex', i === flkty.selectedIndex ? '0' : '-1');
        });
      }
      flkty.on('change', updateSlideFocus);
      updateSlideFocus();

      /* Clean up on theme editor section unload */
      var editorSection = el.closest('[data-shopify-editor-section]');
      if (editorSection) {
        editorSection.addEventListener('shopify:section:unload', function () {
          flkty.destroy();
        }, { once: true });
      }
    });
  }

  /* ----------------------------------------
     Initialize
     ---------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.hje2o-hero') ||
        e.target.querySelector('.hje2o-countdown') ||
        e.target.querySelector('.hje2o-content') ||
        e.target.querySelector('.hje2o-carousels') ||
        e.target.querySelector('.hjlp-faq')) {
      init();
    }
  });
})();
